import { RootState } from "@/shared/types";
import { IVendorsData, IGetManyVendorsParams } from "./types/interfaces";

export const selectVendors = (state: RootState): IVendorsData =>
  state.vendors.data;

export const selectParams = (state: RootState): IGetManyVendorsParams =>
  state.vendors.params;
